import React, {Component, useState, useRef, useEffect} from 'react';
import { connect } from 'react-redux';

import Template from "../template/template";
import Button from "../../ui/components/buttons/button";
import FormTextField from "../../ui/components/form-controls/form-text-field";
import FormDateField from "../../ui/components/form-controls/form-date-field";

import {withRouter} from "react-router-dom";
import RadioBox from "../radio-box";

import "./quote-review.css";
import {_getPolicy, _ratePolicy, _storePolicy} from "../../store/policy/service";
import FormSelectField from "../../ui/components/form-controls/form-select-field";
import {useTranslation} from "react-i18next";
import * as moment from "moment";
import {_getSite, _getStep, _hideSpinner, _showError, _showSpinner} from "../../store/system/service";
import {_formatAmount, _removeFormatting, _isNotDecimalChar, _scrollToComponent, _gaPushEvent, _gaPushData, _sendLog} from "../../utils/utility"
import {Formik, Form, Field} from "formik";
import * as yup from "yup";
import BalloonTip from "../balloon-tip/balloon-tip";
import ErrorMessage from '../error-message';

const QuoteReview = (props) => {
    const premiseOwnershipTypeOptions = [
        {
            label: 'Rent',
            value: 'rent'
        },
        {
            label: 'Own',
            value: 'own'
        }
    ]

    const annualTurnoverOptions = [
        {
            "text": "Up to $1,000,000",
            "value": "1"
        },
        {
            "text": "$1,000,001 to $2,000,000",
            "value": "2"
        },
        {
            "text": "$2,000,001 to $3,000,000",
            "value": "3"
        },
        {
            "text": "$3,000,001 to $4,000,000",
            "value": "4"
        },
        {
            "text": "$4,000,001 to $5,000,000",
            "value": "5"
        },
        {
            "text": "$5,000,001 to $6,000,000",
            "value": "6"
        },
        {
            "text": "$6,000,001 to $7,000,000",
            "value": "7"
        },
        {
            "text": "$7,000,001 to $8,000,000",
            "value": "8"
        },
        {
            "text": "$8,000,001 to $9,000,000",
            "value": "9"
        },
        {
            "text": "$9,000,001 to $11,000,000",
            "value": "10"
        },
        {
            "text": "$11,000,001 to $13,000,000",
            "value": "11"
        },
        {
            "text": "$13,000,001 to $15,000,000",
            "value": "12"
        },
        {
            "text": "$15,000,001 to $17,000,000",
            "value": "13"
        },
        {
            "text": "$17,000,001 to $19,000,000",
            "value": "14"
        },
        {
            "text": "$19,000,001 to $20,000,000",
            "value": "15"
        }
    ]

    const { t, i18n } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
        // Google Analytics
        _gaPushData({
            'pageStep': 'Quote – Business Info',
            'vPath': '/quote-business-info',
            'event': 'vpageview'
        });
    }, [])

    const confirm = (values, setSubmitting) => {
        if (!values.premiseOwnershipType) {
            props.showError(['Please select ownership type']);
            setSubmitting(false);
            return;
        }

        // Google Analytics
        _gaPushEvent('confirmgetquote');

        props.policy.policySME.situationTurnoverCode = values.annualTurnover;
        props.policy.policySME.numberOfEmployees = values.noOfEmployee;
        props.policy.policySME.annualWages = _removeFormatting(values.estimatedAnnualSalaries);
        props.policy.policySME.contentsSI = _removeFormatting(values.contentAmount);

        if (values.premiseOwnershipType === 'own') {
            props.policy.policySME.buildingSI = _removeFormatting(values.buildingAmount);
        }
        else {
            props.policy.policySME.buildingSI = 0;
        }

        props.policy.policySME.ownershipType = values.premiseOwnershipType;

        // set site
        props.policy.policySME.site = props.site;

        props.policy.policySME.inceptionDate = moment().format('DD/MM/YYYY');
        // set expiry date
        props.policy.policySME.expiryDate = moment().add(1, 'years').subtract(1, 'days').format('DD/MM/YYYY');
        props.policy.errorMessage = "";

        props.storePolicy(props.policy);
        props.showSpinner();
        props.ratePolicy().then ( resp => {
            setSubmitting(false);
            props.hideSpinner();
            
            if(resp.errorMessage){
                console.error(resp.errorMessage);
                _sendLog(['SME-React - Quote Review - PolicyRate service returned an error: ', resp.errorMessage]);
                props.showError([resp.errorMessage]);
            } else {
                props.history.push((props.site ? '/' + props.site : '') + '/quote/summary');
            }
        }, (error) => {
            setSubmitting(false);
            props.hideSpinner();
            console.error(error?.response?.data?.message);
            _sendLog(['SME-React - Quote Review - Encountered a server error while calling PolicyRate service: ', error?.response?.data?.message]);
            props.showError(['Encountered a server error. Please try again later.']);
        });
    }

    const topCompRef = useRef(null);
    const bottomCompRef = useRef(null);

    yup.addMethod(yup.string, 'maximumStringValue', (limit, errMessage) => {
        let yupString = yup.string();
        return yupString.test('testStringMaxValue', errMessage, function(val) {
            let numericVal = Number(_removeFormatting(val));
            return numericVal > limit ? false : true;
        });
    });
    const validationSchema = yup.object().shape({
        annualTurnover: yup.string()
            .required(() => {
                if(window.innerWidth>768){
                    _scrollToComponent(topCompRef);
                }
                return t('annualTurnover.validationMessage.required');
            }),
        noOfEmployee: yup.number()
            .required(() => {
                if(window.innerWidth>768){
                    _scrollToComponent(topCompRef);
                }
                return t('noOfEmployee.validationMessage.required');
            })
            .max(100, () => {
                if(window.innerWidth>768){
                    _scrollToComponent(topCompRef);
                }
                return t('quote.review.validation.maxNoOfEmployees');
            }),
        estimatedAnnualSalaries: yup.string()
            .required(() => {
                if(window.innerWidth>768){
                    _scrollToComponent(topCompRef);
                }
                return t('estimatedAnnualSalaries.validationMessage.required');
            }),
        premiseOwnershipType: yup.string(),
        hiddenAmount: yup.number(),
        buildingAmount: yup.string()
            .when('contentAmount', (value, schema) => {
                // When contentAmount is empty then set to required and max is 15,000,000
                if(!value || (""+value).trim() == "") {
                    return schema.maximumStringValue(15000000, t('quote.review.validation.maxContentAmount'))
                        .required(() => {
                            if(window.innerWidth>768) {
                                _scrollToComponent(bottomCompRef);
                            }
                            return t('buildingAmount.validationMessage.required');
                        })
                } else {
                    // When contentAmount has a value adjust available max.
                    return schema.maximumStringValue(15000000 - Number(_removeFormatting(value)), t('quote.review.validation.maxContentAmount'));
                }
            }),
        contentAmount: yup.string()
            .maximumStringValue(15000000, t('quote.review.validation.maxContentAmount'))
            .when('hiddenAmount', (value, schema) => {
                if(value <= 0) {
                    return schema.required(() => {
                        if(window.innerWidth>768) {
                            _scrollToComponent(topCompRef);
                        }
                        return t('contentAmount.validationMessage.required');
                    })
                } else {
                    // Adjust available max when buildingAmount has a value (unable to reference buildingAmount directly).
                    return schema.maximumStringValue(15000000 - Number(_removeFormatting(value)), t('quote.review.validation.maxContentAmount'))
                }
            })
    });

    const initialValues = {
        annualTurnover: props.policy.policySME.situationTurnoverCode || "",
        noOfEmployee: props.policy.policySME.numberOfEmployees || "",
        estimatedAnnualSalaries: _formatAmount(props.policy.policySME.annualWages, i18n.language, t("currency.prefix")),
        contentAmount: _formatAmount(props.policy.policySME.contentsSI, i18n.language, t("currency.prefix")),
        buildingAmount: _formatAmount(props.policy.policySME.buildingSI, i18n.language, t("currency.prefix")),
        premiseOwnershipType: props.policy.policySME.ownershipType || "",
        hiddenAmount: 0
    };

    return (
        <Template simple="Quotation" step={props.step} policy={props.policy} site={props.site} prevPage="/quote/product">
            <Formik 
                initialValues = {initialValues} 
                validationSchema ={validationSchema}
                onSubmit = {(values, {setSubmitting}) => {
                    setSubmitting(true);
                    confirm(values, setSubmitting);
                }}>
                {({values, errors, touched, handleBlur, handleChange, isSubmitting}) => (
                    <Form>
                        <div className="QuoteAmendTitleGroupStyle">
                            <div className="QuoteAmendTitleStyle">Help us know more about your business.</div>
                        </div>

                        <div className="QuoteAmendInputGroupsStyle" ref={topCompRef}>

                            <div className="QuoteAmendInputGroupStyle">
                                <div className="QuoteAmendInputBoxStyle">
                                    <Field 
                                        name="annualTurnover"
                                        label="Estimated Annual Turnover/Revenue"
                                        options={annualTurnoverOptions} 
                                        as={FormSelectField}
                                        onChange={(selectedValue) => {
                                            values.annualTurnover = selectedValue;
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="QuoteAmendInputGroupStyle">
                                <div className="QuoteAmendInputBoxStyle">
                                    <Field 
                                        name="noOfEmployee" 
                                        label="No. of Employee(s) to be Insured"
                                        inputMode={'numeric'}
                                        errorMessage={touched.noOfEmployee && errors.noOfEmployee ? errors.noOfEmployee : ""} 
                                        as={FormTextField}
                                        onKeyPress={(event) => {
                                            if(_isNotDecimalChar(event.key)){
                                                event.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="QuoteAmendInputGroupStyle">
                                <div className="QuoteAmendInputBoxStyle">
                                    <Field
                                        label="Estimated Annual Salaries"
                                        name="estimatedAnnualSalaries"
                                        as={FormTextField}
                                        inputMode={'numeric'}
                                        errorMessage={touched.estimatedAnnualSalaries && errors.estimatedAnnualSalaries ? errors.estimatedAnnualSalaries : ""}
                                        onBlur={(event) => {
                                            handleBlur(event);
                                            values.estimatedAnnualSalaries = _formatAmount(event.target.value, i18n.language, t("currency.prefix"));
                                        }}
                                        onKeyPress={(event) => {
                                            if(_isNotDecimalChar(event.key)){
                                                event.preventDefault();
                                            }
                                        }}
                                    />
                                    <div className="balloonTip">
                                        <BalloonTip>
                                            <span>Estimated Annual Salaries refers to wages, salaries and other monetary
                                                earnings which must consist of the normal wages, food and housing
                                                allowances, overtime payments, bonuses and annual wages supplements but
                                                excluding travelling allowances and employer’s CPF contributions estimated
                                                to be paid during the period of insurance.</span>
                                        </BalloonTip>
                                    </div>
                                </div>
                            </div>

                            <div className="QuoteAmendInputGroupStyle">
                                <div className="QuoteAmendInputBoxStyle">
                                    <Field
                                        label="Physical Assets Value"
                                        name="contentAmount"
                                        as={FormTextField}
                                        errorMessage={touched.contentAmount && errors.contentAmount ? errors.contentAmount : ""}
                                        onBlur={(event) => {
                                            handleBlur(event);
                                            values.contentAmount = _formatAmount(event.target.value, i18n.language, t("currency.prefix"));
                                        }}
                                        inputMode={'numeric'}
                                        onKeyPress={(event) => {
                                            if(_isNotDecimalChar(event.key)){
                                                event.preventDefault();
                                            }
                                        }}
                                    />
                                    <div className="balloonTip">
                                        <BalloonTip>
                                            <span>Contents of every description including furniture, furnishings,
                                                fixtures, fittings, stocks, machinery & fixed glass.</span>
                                        </BalloonTip>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="QuoteAmendInputGroupHeadStyle">
                            <div className="QuoteAmendInputGroupTitleStyle">
                                Premise Ownership Type
                            </div>
                        </div>

                        <div className="QuoteAmendInputRadioBoxStyle">
                            <Field
                                name="premiseOwnershipType"
                                options={premiseOwnershipTypeOptions}
                                as={RadioBox}
                                onChange={(event) => {
                                    if(event.target.value == 'rent'){
                                        values.buildingAmount = '';
                                        values.hiddenAmount = 0;
                                    }
                                    handleChange(event);
                                }}
                            />
                        </div>
                        {
                            values.premiseOwnershipType === 'own' &&
                            <div className="QuoteAmendInputGroupStyle"  ref={bottomCompRef}>
                                <div className="QuoteAmendInputBoxStyle">
                                    <Field
                                        label="Premise Value"
                                        name="buildingAmount"
                                        as={FormTextField}
                                        inputMode={'numeric'}
                                        errorMessage={touched.buildingAmount && errors.buildingAmount ? errors.buildingAmount : ""}
                                        onBlur={(event) => {
                                            values.buildingAmount = _formatAmount(event.target.value, i18n.language, t("currency.prefix"));
                                            handleBlur(event);
                                        }}
                                        onKeyPress={(event) => {
                                            if(_isNotDecimalChar(event.key)){
                                                event.preventDefault();
                                            }
                                        }}
                                        onChange={(event) => {
                                            values.hiddenAmount = Number(_removeFormatting(event.target.value));
                                            handleChange(event);
                                        }}
                                    />
                                </div>
                            </div>
                        }

                        <div className="QuoteAmendInputButtonsGroupStyle">
                            <div className="QuoteAmendInputButtonsStyle">
                                <Button color="primary" type="submit" disabled={isSubmitting}>Confirm</Button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </Template>
    );
}

// get status from redux (subscription)
const mapStateToProps = (state) => {
    const currPolicy = _getPolicy(state);

    return {
        policy: currPolicy,
        step: _getStep(state),
        site: _getSite(state)
    }
}

// send service request to redux
const mapDispatchToProps = {
    showError: _showError,
    storePolicy: _storePolicy,
    ratePolicy: _ratePolicy,
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuoteReview));
